import styles from './index.module.scss'
import { commonMenus } from "../../utils/menus";
import { RightOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom'
const NavbarMenus = ({ path }) => {
    const history = useNavigate()

    const jump = function (path) {
        // 页面跳转方法
        history({pathname: '/' + path})
    }
    return (
        <div className={styles.navbarMenus}>
            {
                commonMenus.map(item => {
                    return (
                        <ul key={item.label}>
                            <div className={styles.title}>{item.label}<RightOutlined /></div>
                            {
                                item.children.map(cli => {
                                    return (
                                        <li key={cli.label} onClick={jump.bind(this, cli.key)} className={path === cli.key ? styles.active : ''}>
                                            {cli.label}
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    )
                })
            }
        </div>
    )
}

export default NavbarMenus
